// extracted by mini-css-extract-plugin
module.exports = {"heading":"PageHeading_heading__JTdO6","subPanel":"PageHeading_subPanel__2N-Nf"};